export const stateToPageid = {
    "preview": "preview",
    "live": "gameday",
    "final": "recap"
};

const UNDEF = undefined;

export default {
    setGameData: function(data) {
        this.currentGameData = data;
    },

    getGameData: function(data) {
        return this.currentGameData;
    },

    setConf: function(conf) {
        if (conf?.adsConfig) {
            this.adConf = conf;
        }
    },

    setGameView: function(view) {
        this.gameView = view;
    },

    setGameTab: function(tab) {
        this.gameTab = tab;
    },

    getGameView: function(view) {
        return this.gameView;
    },

    getGameTab: function(tab) {
        return this.gameTab;
    },

    setInstance : function(instance) {
        this.adEngine = instance;
    },

    getInstance : function() {
        return this.adEngine;
    },

    getKeyVals: function(gameData) {
        const { inningState, teams, currentInning, gamePk, gameState } = gameData || this.currentGameData || {};
        const home = teams?.home?.teamCode;
        const away = teams?.away?.teamCode;
        const state = stateToPageid[this.gameView] || stateToPageid.live;
        const inning = currentInning?.toString() || UNDEF;
        const status = inningState?.toLowerCase() || UNDEF;
        const { adsConfig: {
            pageid = '',
            env = 'production',
            iu = '',
            prerollIu,
            pp = '',
            cmsid
        } = {} } = this.adConf || {};

        const keyVals = "gid=" + gamePk + ";team=" + home + ";team=" + away + ";pageid=" + state
            + (inning ? ";inning=" + inning : '') 
            + (status ? ";status=" + status : '') 
            + ";";

        window.dc_keyVal = keyVals;

        /* GPT set the page-level targeting params */
        var pageTargeting = {
            gid: gamePk + '',
            pageid: pageid || state,
            team: [home, away],
            env: (env !== 'prod' ? env : 'production') || 'production'
        };

        if (inning) {
            pageTargeting.inning = inning;
        }

        if (status) {
            pageTargeting.status = status;
        }

        return {
            data: {
                gamePk,
                inning,
                status,
                teams: [home, away],
                env,
                gameState,
                iu,
                pp,
                prerollIu,
                cmsid
            },
            keyVals: keyVals,
            pageTargeting: pageTargeting
        }
    }
}
